module.exports = __webpack_public_path__ + "static/dd1-089689a52384c289e839fa789cef6643.jpg";